module.exports = __webpack_public_path__ + "img/SMT_14_Ms_See_Yen_Theng.d9a3e7b9.jpg";